module.exports = __webpack_public_path__ + "img/8.7afb856d.jpg";